import { RemoteLoadNewRouteSuggestion } from '@/javascript/data/usecases/maps'
import { LoadNewRouteSuggestion } from '@/javascript/domain/usecases'
import { makeApiUrl, makeAxiosHttpClient } from '@/javascript/main/factories/http'
import { makeRouteSuggestionMapper } from '@/javascript/main/factories/mappers'

export const makeRemoteLoadNewRouteSuggestion = (): LoadNewRouteSuggestion =>
  new RemoteLoadNewRouteSuggestion(
    makeApiUrl('/maps/route_suggestion'),
    makeAxiosHttpClient(),
    makeRouteSuggestionMapper()
  )
